import React, { Fragment, useState } from "react";

import ModalComponent from "@/components/modal";

import "@/styles/pages/auth/registration-categories.scss";
import ButtonComponent from "@/components/button/Button";
import { useDispatch } from "react-redux";
import { setCurrentForm } from "@/reducers/commonSlice";
import { updateUserRole } from "@/services/users/updateUserRole";

const RegistrationCategories = ({ isOpen = false }) => {
  const [selectedRole, setSelectedRole] = useState("Student");
  const dispatch = useDispatch();
  const handleClick = (role) => {
    setSelectedRole(role);
  };

  const handleContinue = () => {
    console.log(selectedRole, "selectedRole");

    updateUserRole({
      userRole: selectedRole,
    })
      .then((response) => {
        console.log(response);
        if (selectedRole === "Guide") {
          dispatch(setCurrentForm("guidePlatform"));
        } else {
          dispatch(setCurrentForm("journeySelection"));
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <Fragment>
      <ModalComponent buttonLabel="Categories" isOpen={isOpen} className="onboarding-modal">
        <div className="registration-categories-modal">
          <div className="heading">
            <div className="title-h5-1">Who are you?</div>
            <div className="body-b4">Let us know by selecting one of the given options.</div>
          </div>
          <div className="categories">
            <div
              className={`card ${selectedRole === "Student" ? "selected" : ""}`}
              onClick={() => handleClick("Student")}
            >
              <div className="image-container">
                <img
                  src="/assets/images/illustration-student.svg"
                  alt="Student"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="content">
                <div className="title-h5-1">Student</div>
                <div className="body-b3">(Here to Seek Guidance)</div>
              </div>
            </div>
            <div
              className={`card ${selectedRole === "Guide" ? "selected" : ""}`}
              onClick={() => handleClick("Guide")}
            >
              <div className="image-container">
                <img
                  src="/assets/images/illustration-guide.svg"
                  alt="Guide"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="content">
                <div className="title-h5-1">Mentor</div>
                <div className="body-b3">(Here to Offer Guidance)</div>
              </div>
            </div>
          </div>
          <ButtonComponent
            label="Continue"
            varient="primary"
            className="w-100"
            onClick={handleContinue}
          ></ButtonComponent>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default RegistrationCategories;
